import { ResolvedSite } from "@libry-content/common";
import { PrivacyPolicy } from "@libry-content/types";
import max from "date-fns/max";

// Bump this date to now when the hardcoded text is updated
const HARDCODED_TEXT_UPDATED = "2024-12-04T14:00:00.000Z";

export const getPrivacyPolicyPublishedDate = (
  site: ResolvedSite,
  privacyPolicy: Pick<PrivacyPolicy, "trackUpdatedFields">
): Date => {
  const candidateDates = [new Date(HARDCODED_TEXT_UPDATED), new Date(site._createdAt)];

  if (privacyPolicy?.trackUpdatedFields?.updated) {
    candidateDates.push(new Date(privacyPolicy?.trackUpdatedFields?.updated));
  }

  return max(candidateDates);
};
